import React, { Fragment, useEffect, useState } from "react";
import { CopyIcon, CrossIcon, RightArrowIcon } from "../../../assets/icons";
import PreviewPage from "./learnosityPreviewPage";
import { HumanIcon, MachineIcon } from "../../../assets/icons/index";
import { Link } from "react-router";
import constant from "../../../utils/constant";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import {
  postQuestionTag,
  deleteQuestionTag,
  getQuestionSettings,
  getQuestionGuid,
} from "../../../api/question.service";
import Copy from "../../shared/common/copy";
import QuestionExplanationPopup from "../../shared/common/questionExplanationPopup";
import { IQuestionSetting } from "../../../model/interface/questionSetting";
import { IVideoExplanation } from "../../../model/interface/videoExplanation";
import { CopyToClipboard } from "../../shared/common/CustomCopyToClipboard";

export default function PreviewModal(props: any) {
  const [disablePrev, setDisablePrev] = useState<boolean>(true);
  const [disableNext, setDisableNext] = useState<boolean>(false);
  const [spanishVersion, setSpanishVersion] = useState<boolean>(false);
  const [showTextToSpeech, setShowTextToSpeech] = useState<boolean>(false);
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [textExplanation, setTextExplanation] = useState<string>("");
  const [videoExplanation, setVideoExplanation] =
    useState<IVideoExplanation | null>(null);
  const [rubric, setRubric] = useState<string>("");
  const [showTextExplanation, setShowTextExplanation] =
    useState<boolean>(false);
  const [showRubric, setShowRubric] = useState<boolean>(false);
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [questionSettings, setQuestionSettings] = useState<
    Array<IQuestionSetting>
  >([]);
  const [questionGuid, setQuestionGuid] = useState<string>();

  const getSettings = () => {
    if (!props.isTeacherQuestion && props.questionIdPreview > 0) {
      getQuestionSettings(props.questionIdPreview).then((response) => {
        setQuestionSettings(response.data);
        setVideoExplanation(getVideoExplanation());
      });
    }
  };

  const requestQuestionGuid = () => {
    if (!props.isTeacherQuestion && props.questionIdPreview > 0) {
      getQuestionGuid(props.questionIdPreview).then((response) => {
        setQuestionGuid(response.data);
      });
    }
  };

  function displayTextExplanationPopup() {
    setVideoUrl("");
    setShowTextExplanation(true);
    setShowRubric(false);
    setShowPopup(true);
  }

  function displayRubricPopup() {
    setVideoUrl("");
    setShowTextExplanation(false);
    setShowRubric(true);
    setShowPopup(true);
  }

  function showVideoExplanation(videoExplanation: IVideoExplanation) {
    setVideoExplanation(videoExplanation);
    setVideoUrl(videoExplanation.explanation);
    setShowTextExplanation(false);
    setShowPopup(true);
  }

  useEffect(() => {
    getSettings();
    requestQuestionGuid();
  }, [props.questionIdPreview]);

  useEffect(() => {
    if (props.questions) {
      const question = props.questions.find(
        (q) => q.questionId === props.questionIdPreview
      );

      setSelectedTagIds(question?.tags?.map((item) => item.tagId));
    }
  }, [props.questionIndexPreview, props.questionIdPreview]);

  const handleFilterTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);
    setSelectedTagIds(selectedTagIds);

    let index = 0;
    if (typeof props.questionIndexPreview !== "number") {
      index = props.questions?.findIndex(
        (element, index) => element.questionId == props.questionIdPreview
      );
    } else {
      index = props.questionIndexPreview;
    }
    const questionId = props?.questions[index]?.questionId;

    const tag = {
      questionId: Number(questionId),
      tagId: selectedTagIds,
    };
    setSelectedTagIds(selectedTagIds);
    postQuestionTag(tag);
  };

  const handleRemoveTag = (allTags, tag) => {
    if (props.questions) {
      const selectedTagIds = allTags
        .filter((t) => t.selected === true)
        .map((t) => t.tagId);

      const question = props.questions.find(
        (q) => q.questionId === props.questionIdPreview
      );
      const tagParam = {
        questionId: Number(question?.questionId),
        tagId: tag.tagId,
      };

      setSelectedTagIds(selectedTagIds);
      deleteQuestionTag(tagParam);
    }
  };

  const handleUntagged = () => {
    setSelectedTagIds([0]);
  };

  function nextQuestion() {
    let nextIndex = 0;
    let index = 0;

    if (typeof props.questionIndexPreview !== "number") {
      index = props.questions?.findIndex(
        (element, index) => element.questionId == props.questionIdPreview
      );
      nextIndex = index + 1;
      if (nextIndex === props.questions?.length) {
        setDisableNext(false);
      }
    } else {
      index = props.questionIndexPreview;
      nextIndex = props.questionIndexPreview + 1;
      if (nextIndex === props.questions?.length) {
        setDisableNext(false);
      }
    }

    if (index !== undefined) {
      const nextQuestion = props.questions[index + 1];
      if (nextQuestion) {
        props.setQuestionIdPreview(nextQuestion.questionId);
        props.setQuestionToPreview(nextQuestion);
        if (props.setQuestionIndexPreview)
          props.setQuestionIndexPreview(nextIndex);
        if (spanishVersion) {
          props.setPreviewId(nextQuestion.spanishQuestionReferenceId);
        } else {
          props.setPreviewId(nextQuestion.englishQuestionReferenceId);
        }
      }
      if (index + 1 == props.questions.length) {
        setDisableNext(true);
      } else {
        setDisablePrev(false);
      }
    }
  }

  function prevQuestion() {
    let previousIndex = 0;
    let index = 0;
    if (typeof props.questionIndexPreview !== "number") {
      index = props.questions?.findIndex(
        (element, index) => element.questionId == props.questionIdPreview
      );
      if (index - 1 > 0) previousIndex = index - 1;
    } else {
      index = props.questionIndexPreview;
      previousIndex = props.questionIndexPreview - 1;
      if (previousIndex == 0) setDisablePrev(true);
    }
    if (index !== undefined && index > 0) {
      const prevQuestion = props.questions[previousIndex];
      if (prevQuestion) {
        props.setQuestionIdPreview(prevQuestion.questionId);
        props.setQuestionToPreview(prevQuestion);
        if (spanishVersion) {
          props.setPreviewId(prevQuestion.spanishQuestionReferenceId);
        } else {
          props.setPreviewId(prevQuestion.englishQuestionReferenceId);
        }
        if (props.setQuestionIndexPreview)
          props.setQuestionIndexPreview(previousIndex);
      }
      if (previousIndex == 0) {
        setDisablePrev(true);
      } else {
        setDisableNext(false);
      }
    }
  }

  function showSpanishVersion(e) {
    setSpanishVersion(e.target.checked);
    if (props.questions?.length > 1 || props.questionToPreview) {
      if (e.target.checked && props.questionToPreview) {
        props.setPreviewId(props.questionToPreview.spanishQuestionReferenceId);
      } else {
        props.setPreviewId(props.questionToPreview.englishQuestionReferenceId);
      }
    } else {
      if (e.target.checked && props.spanishActivityRef) {
        props.setPreviewId(props.spanishActivityRef);
      } else {
        props.setPreviewId(props.englishActivityRef);
      }
    }
  }

  const getVideoExplanation = (): IVideoExplanation => {
    const questionSetting: IQuestionSetting | undefined = questionSettings.find(
      (r) => r.languageId === (spanishVersion ? 2 : 1)
    );

    let explanation = "";
    if (questionSetting) {
      explanation = questionSetting.videoExplanation
        ? questionSetting.videoExplanation.trim()
        : "";
    }

    return {
      explanation: explanation,
      vttUrl: questionSetting?.videoExplanationVttUrl || null,
    } as IVideoExplanation;
  };

  return (
    <>
      {showPopup && (
        <QuestionExplanationPopup
          showPopUp={(show) => {
            setShowPopup(show);
          }}
          textExplanation={
            showRubric ? rubric : showTextExplanation ? textExplanation : ""
          }
          videoUrl={videoUrl}
          vttUrl={videoExplanation?.vttUrl || null}
          studentType={""}
          itemRef={props.itemRef}
        />
      )}
      {props.show ? (
        <>
          <div className="fixed inset-0 z-50  flex items-center sm:items-center sm:justify-center">
            <div className="w-[1280px] flex flex-col justify-between overflow-hidden h-[850px] bg-white rounded-t-lg dark:bg-gray-800 sm:rounded-lg sm:m-4 ">
              <header className="px-4 pt-4 bg-gray-50 relative">
                <div className="flex w-full">
                  {/* Tags belong to global questions; the tag endpoints take a
                      global question id, so a teacher question id would tag an
                      unrelated question. */}
                  {!props.isTeacherQuestion && (
                    <div className="flex contentArea">
                      <TagSelector
                        label={"Tags"}
                        onTagSelectChange={(tags) => {
                          handleFilterTags(tags);
                        }}
                        onFilterUntagged={() => {
                          handleUntagged();
                        }}
                        removeTag={handleRemoveTag}
                        mode={TagSelectorMode.Filter}
                        categoryId={3}
                        selectedTagIds={selectedTagIds}
                      />
                    </div>
                  )}
                  <div className="w-full flex justify-end items-center">
                    {props.questionIdPreview ? (
                      <>
                        {!props.isTeacherQuestion && questionGuid && (
                          <div className="flex space-x-2 pr-5">
                            Public Id -
                            <Link
                              className="pl-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                              target="_blank"
                              to={constant.PUBLIC_ITEM_PREVIEW.replace(
                                ":id",
                                questionGuid
                              )}
                            >
                              {questionGuid}
                            </Link>
                            <div>
                              <CopyToClipboard
                                text={`${
                                  location.origin
                                }${constant.PUBLIC_ITEM_PREVIEW.replace(
                                  ":id",
                                  questionGuid
                                )}`}
                              >
                                <CopyIcon
                                  className="h-5 cursor-pointer"
                                  title="Copy public link"
                                />
                              </CopyToClipboard>
                            </div>
                          </div>
                        )}
                        <div className="flex space-x-2 pr-5">
                          Question Id -
                          <Link
                            className="pl-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            target="_blank"
                            to={
                              props.isTeacherQuestion
                                ? constant.crmUserContentQuestionEdit
                                    .replace(
                                      ":userid",
                                      String(
                                        props.teacherQuestionOwnerUserId ?? ""
                                      )
                                    )
                                    .replace(
                                      ":teacherQuestionId",
                                      props.questionIdPreview.toString()
                                    )
                                : constant.MANAGEQUESTION.replace(
                                    ":id",
                                    props.questionIdPreview.toString()
                                  )
                            }
                          >
                            {props.questionIdPreview}
                          </Link>
                          <div>
                            <CopyIcon
                              className="h-5 cursor-pointer"
                              title="Copy id"
                              onClick={() =>
                                Copy(
                                  props.questionIdPreview
                                    ? [props.questionIdPreview]
                                    : [props.activityIdPreview]
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : props.activityIdPreview ? (
                      "Activity Id- " + props.activityIdPreview
                    ) : null}

                    <div>
                      <button
                        className="text-xl"
                        onClick={() => {
                          props.changeValue(false);
                          setDisableNext(false);
                          setSpanishVersion(false);
                          if (props.setQuestionIndexPreview instanceof Function)
                            props.setQuestionIndexPreview(undefined);
                        }}
                      >
                        <CrossIcon className="w-6"></CrossIcon>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between my-4">
                  <div className="flex items-center space-x-4">
                    {!props.isTeacherQuestion && (
                      <>
                        <dl className="mb-0">
                          <label
                            htmlFor="toggleSpanish"
                            className="flex items-center cursor-pointer pl-1"
                          >
                            <div className="relative">
                              <input
                                id="toggleSpanish"
                                type="checkbox"
                                className="sr-only"
                                onChange={(e) => showSpanishVersion(e)}
                              />
                              <div className="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                              <div
                                className={`${
                                  spanishVersion
                                    ? "bg-primary-color toggle-btn"
                                    : "bg-white"
                                } absolute w-6 h-6 rounded-full shadow -left-1 -top-1 transition`}
                              ></div>
                            </div>
                            <div className="ml-3 text-gray-700 font-medium">
                              Spanish Version
                            </div>
                          </label>
                        </dl>
                        {(props.questions?.length > 1 ||
                          props.questionToPreview) &&
                          (props.questionToPreview?.isHumanTranslated ? (
                            <HumanIcon
                              title="Human Translated"
                              className="w-4 h-4"
                            />
                          ) : (
                            <MachineIcon
                              title="Machine Translated"
                              className="w-4 h-4"
                            />
                          ))}
                        {rubric && rubric !== "" && (
                          <a
                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            onClick={() => {
                              displayRubricPopup();
                            }}
                          >
                            Rubric
                          </a>
                        )}
                        {textExplanation && textExplanation !== "" && (
                          <a
                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            onClick={() => {
                              displayTextExplanationPopup();
                            }}
                          >
                            Text Explanation
                          </a>
                        )}

                        {videoExplanation !== null && (
                          <a
                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                            onClick={() => {
                              showVideoExplanation(getVideoExplanation());
                            }}
                          >
                            Video Explanation
                          </a>
                        )}
                      </>
                    )}
                  </div>
                  {/* TTS and Prev/Next form one right-aligned cluster (TTS on the left), so TTS
                      stays on the right side whether or not Prev/Next renders. */}
                  <div className="flex items-center space-x-4">
                    <div>
                      <dl className="mb-0">
                        <label
                          htmlFor="toogleTTS"
                          className="flex items-center cursor-pointer pl-1"
                        >
                          <div className="relative">
                            <input
                              id="toogleTTS"
                              type="checkbox"
                              className="sr-only"
                              onChange={(e) => {
                                setShowTextToSpeech(e.target.checked);
                              }}
                            />
                            <div className="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                            <div
                              className={`${
                                showTextToSpeech
                                  ? "bg-primary-color toggle-btn"
                                  : "bg-white"
                              } absolute w-6 h-6 rounded-full shadow -left-1 -top-1 transition`}
                            ></div>
                          </div>
                          <div className="ml-3 text-gray-700 font-medium">
                            TTS
                          </div>
                        </label>
                      </dl>
                    </div>
                    {props.questions?.length > 1 && (
                      <div>
                        <button
                          onClick={prevQuestion}
                          type="button"
                          disabled={disablePrev}
                          className={`${
                            disablePrev
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          } mr-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300`}
                        >
                          <RightArrowIcon className="w-5 transform rotate-180"></RightArrowIcon>
                          Prev
                        </button>
                        <button
                          onClick={nextQuestion}
                          type="button"
                          disabled={disableNext}
                          className={`${
                            disableNext
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          } mr-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300`}
                        >
                          <RightArrowIcon className="w-5"></RightArrowIcon>
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </header>
              <div className="w-full h-full relative overflow-auto px-4 py-3 ">
                <img
                  alt="Progress Learning"
                  src="/images/logo-pl.svg"
                  className="w-16 ml-4 mb-1 "
                />
                <PreviewPage
                  key={
                    props.itemRef
                      ? `${props.itemRef}-${showTextToSpeech}`
                      : props.activityRef
                  }
                  itemRef={props.itemRef}
                  activityRef={props.activityRef}
                  showTextToSpeech={showTextToSpeech}
                  setShowTextToSpeech={setShowTextToSpeech}
                  onSetTextExplanation={(textExplanation: string) => {
                    setTextExplanation(textExplanation);
                  }}
                  onSetRubric={(rubric: string) => {
                    setRubric(rubric);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
